import React from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import HomeIcon from '@mui/icons-material/Home';

const NotFound: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
        p: { xs: 2, sm: 3 }
      }}
    >
      <Paper
        sx={{
          maxWidth: 500,
          p: { xs: 3, sm: 5 },
          textAlign: 'center',
          borderRadius: 2
        }}
        elevation={3}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '5rem', sm: '8rem' },
            fontWeight: 'bold',
            color: 'primary.main',
            mb: 2
          }}
        >
          404
        </Typography>
        
        <Typography
          variant="h5"
          sx={{
            mb: 2,
            fontSize: { xs: '1.2rem', sm: '1.5rem' },
            fontWeight: 'medium'
          }}
        >
          ページが見つかりませんでした
        </Typography>
        
        <Typography
          variant="body1"
          sx={{
            mb: 4,
            color: 'text.secondary',
            fontSize: { xs: '0.875rem', sm: '1rem' }
          }}
        >
          お探しのページは削除されたか、URLが間違っている可能性があります。
        </Typography>
        
        <Button
          variant="contained"
          component={Link}
          to="/jobs"
          startIcon={<HomeIcon />}
          sx={{
            py: 1.5,
            px: 3,
            fontWeight: 'medium',
            fontSize: { xs: '0.875rem', sm: '1rem' }
          }}
        >
          求人一覧に戻る
        </Button>
      </Paper>
    </Box>
  );
};

export default NotFound;